<script setup>
import {defineProps, toRefs, computed, ref} from "vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({
			value: ''
    })
  },
});
const {data} = toRefs(props);

</script>

<template>
  <div v-html="data.value"></div>
</template>

<style lang="scss" scoped>

</style>